import { render, staticRenderFns } from "./activity-info.vue?vue&type=template&id=f9c9b246&scoped=true&"
import script from "./activity-info.vue?vue&type=script&lang=js&"
export * from "./activity-info.vue?vue&type=script&lang=js&"
import style0 from "./activity-info.vue?vue&type=style&index=0&id=f9c9b246&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c9b246",
  null
  
)

export default component.exports